import styled from 'styled-components';

import {
  CircularProgressbar,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { Header as CustomHeader, Text as CustomText } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  flex: 1;
`;

export const ContainerProgressCard = styled.div`
  display: flex;
  height: 150px;
  margin: 10px 0;
`;

export const Header = styled(CustomHeader)`
  color: ${(props) => props.theme.color.text};
`;

export const ProgressBar = styled(CircularProgressbar)`
  &&.CircularProgressbar .CircularProgressbar-path {
    stroke: ${(props) => props.theme.color.success};
  }

  &&.CircularProgressbar .CircularProgressbar-text {
    fill: ${(props) => props.theme.color.text};
    font-weight: 500;
  }
`;

export const Text = styled(CustomText)`
  display: flex;
  justify-content: center;
  color: ${(props) => props.theme.color.text};
`;
